import { getModel } from "./dbService";
import { ChannelkartNetworkGet } from "./networkService";

export const fetchAndStoreClientConfig = async () => {
  try {
    //Reset the filters used in primary and secondary feature.
    sessionStorage.removeItem("sessionStorageDmsFilters");
    sessionStorage.removeItem("bulkInvoiceFilterData");
    const domainTypesToStore = [
      "dms_configuration",
      "catalogue_configuration",
      "customer_configuration",
      "order_configuration",
      "filters_label_configuration",
      "loadout_configuration",
      "salesman_app_options_configuration"
    ];
    const keysToStoreInLocalStorage = [
      "caseUnitLabel",
      "packUnitLabel",
      "otherUnitLabel",
      "mrpLabel",
      "ptrLabel",
      "unitLabel",
      "currency",
      "pieceSizeLabelMapping",
      "uomConversion",
      "orderUomCheck",
      "claimTypes",
      "claimSubTypes",
      "claimTypesObj",
      "uomConversionPrimary",
      "caseUnitLabelPrimary",
      "otherUnitLabelPrimary",
      "packUnitLabelPrimary",
      "multipleCategoryFilterEnabled",
      "shippingAddressMandatory",
      "invoiceExpiryCheck",
      "invoiceExpiryCheckValue",
      "invoiceEditedOnceCheck",
      "primaryOrderTrackingStages",
      "grnStages",
      "orderFulfillmentTimePrimary",
      "activeDmsFeatures",
      "designationBasedUomSecondary",
      "oneClickOrder",
      "secondarySchemesUIConfig",
      "disableOrderEditDesignationBased",
      "useKafkaBulkFlow",
      "usePromoServiceForSchemes",
      "fetchPricingBySalesrep",
      "defaultCatalogueImage",
      "designationBasedUomSecondary",
      "disableOtherUnitNameWiseCavinKair",
      "enableMOQCheck",
      "dateRangeConfig","salesReturnReasons","salesReturnReasonsMap","filterShowRouteLabel",
      "batchIdConfiguration",
      "showSalesReturnWithInvoice",
      "startDateAtLastNDays",
      "createPrimaryOrderUom",
      "showTotalConvertedCasesPrimaryOMS",
      "showPcMrpInCatalogueProductCardPrimary",
      "mergeManageOrderInvoice",
      "displayOtherUnitName",
      "showRouteNameId",
      "subDistributorDesignations",
      "showOutletGstinLabelManageOrders",
      "manageSecondaryOrderV2",
      "quickDateRanges",
      "enableFocPurchaseReturnClaims",
      "decimalFormatting",
      "showSiteWarehouseFilterViewPrimaryOMS",
      "enableManagePrimaryOrderOmsV2",
      "useSalesrepAsLoginIdForSubD",
      "showRouteIdOnly",
      "showLocationIdOnly",
      "useStockValidate",
      "showStatusReasonColumnBulkConfirm",
      "amountScaleConfig",
      "hideMrpLabel",
      "showTableScrollbar",
      "showBatchId",
      "showOperationType",
      "homePageConfiguration",
      "primaryReturnReasons",
      "primaryReturnApproval",
      "caseUnitLabelPrimaryReturn",
      "otherUnitLabelPrimaryReturn",
      "packUnitLabelPrimaryReturn",
      "directInvoicingEnabled",
      "ViewAllGrnV2",
      "PrimaryOrderV2"
    ];
    const dataToStore: Record<string, any> = {};
    const metaData = await ChannelkartNetworkGet("/metadata/clientconfig");
    const clientConfig = metaData?.data?.features ?? [];
    const configsArr: any = [];
    clientConfig.forEach((config: any) => {
      if (domainTypesToStore.includes(config.domainType)) {
        config.domainValues.forEach((obj: any) => {
          configsArr.push({
            domainType: config.domainType,
            configName: obj.name,
            configValue: obj.value,
          });
          if (keysToStoreInLocalStorage.includes(obj.name)) {
            dataToStore[obj.name] = obj.value;
          }
        });
      }
    });
    localStorage.setItem("ConfigDictionary", JSON.stringify(dataToStore));
    const model = await getModel("ClientConfig");
    await model.saveAll(configsArr);
  } catch (err) {
    console.log("Error while storing the client config in db ", err);
  }
};

export const getConfigData = async (domainType: string, key?: string) => {
  const model = await getModel("ClientConfig");
  let query: any = { domainType };
  if (key) {
    query = { ...query, configName: key };
  }
  const result = await model.find(query);
  return result.data;
};
